import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { SalesCalls, SalesCallsToDo, SalesCallsCalendar } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '../../../helper'

const log = new Logger('SalesCallsService')

/**
 * Đây là services dành cho SalesCalls
 */

@Injectable({ providedIn: 'root' })
export class SalesCallsService {
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng cho User
   */
  private _apiPath = {
    list: 'salescalls/salescalls_entity',
    detail: 'salescalls/salescalls_entity',
    calendar: 'salescalls/salescalls_calendar',
    activity_type: 'atsc/atsc_entity',
  }

  /**
   * Lấy tất cả SalesCalls đang available
   * @param params Danh sách tham số muốn truyền.
   * ex: { 'pagesize': 10, 'page':1 }
   */
  getAll(params?: any): Observable<any> {
    // let pa = new HttpParams();
    let pa = new HttpParams().set(
      'parameters[salescalls_business_id]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }
    return this.apiService.get<any>(this._apiPath.list, pa).pipe(
      map(data => {
        return data
      })
    )
  }

  getActivityType(params?: any): Observable<SalesCalls[]> {
    // let pa = new HttpParams();
    let pa = new HttpParams().set(
      'parameters[atsc_business_id]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }
    return this.apiService
      .get<SalesCalls[]>(this._apiPath.activity_type, pa)
      .pipe(
        map(data => {
          return data
        })
      )
  }

  /**
   * Lấy thông tin chi tiết của SalesCalls dưạ vào @id
   * @param Id ID của SalesCalls
   */
  getDetail(id: string): Observable<SalesCalls> {
    return this.apiService
      .get<SalesCalls>(`${this._apiPath.detail}/${id}`)
      .pipe(
        map(data => {
          return data
        })
      )
  }

  /**
   * Tạo SalesCalls
   * @param res Thông tin SalesCalls
   */
  create(res: SalesCalls): Observable<any> {
    res.sid = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Chỉnh sửa thông tin SalesCalls
   *
   * @param res Thông tin SalesCalls muốn chỉnh sửa
   */
  edit(res: SalesCalls): Observable<any> {
    return this.apiService.put(`${this._apiPath.detail}/${res.sid}`, res).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Xóa thông tin SalesCalls
   *
   * @param id Xóa SalesCalls bằng SalesCalls ID
   */
  delete(id): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        return data
      })
    )
  }

  calendar(
    startDate?: number,
    endDate?: number
  ): Observable<SalesCallsCalendar[]> {
    let pa = new HttpParams()
      .set('bid', this.storage.getActiveLocalBusinessID())
      .set('start_date', `${startDate}`)
      .set('end_date', `${endDate}`)
    return this.apiService
      .get<SalesCallsCalendar[]>(this._apiPath.calendar, pa)
      .pipe(
        map(data => {
          return data
        })
      )
  }
}
